import { useNavigate } from 'react-router-dom';

import { AreaScore } from '@/pages/skill/SkillPage.hooks';
import RadarChart, { ChartData } from '@/components/charts/RadarChart';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Skeleton from '@/components/ui/custom/Skeleton';

type Props = {
  areaScores?: AreaScore[];
  loading?: boolean;
};

export default function SkillsRadar(props: Props) {
  const { areaScores = [], loading } = props;

  const navigate = useNavigate();

  function createChartData({ area, tagScore }: AreaScore): ChartData {
    const onClickLabel = area.isLeaf
      ? undefined
      : () => navigate(`/skills/${area.id}`);

    const newData: ChartData = {
      label: area?.name || '',
      value: tagScore.score,
      onClickLabel,
    };

    return newData;
  }

  const chartData = areaScores.map<ChartData>(createChartData);

  if (loading) {
    return (
      <Skeleton className="min-h-[8.125rem] w-full flex rounded-xl bg-secondary-content flex-1" />
    );
  }

  return (
    <ConditionalRenderer condition={areaScores.length}>
      <li className="flex flex-col gap-2 rounded-xl shadow-default p-2.5 min-h-[8.125rem] bg-secondary-content relative flex-1">
        <div className="inset-0 flex items-center justify-center overflow-hidden absolute">
          <RadarChart
            data={chartData}
            chartOptions={{
              label: { size: '0.5rem' },
              seriesName: 'xp',
              offsetX: 10,
              offsetY: 0,
              width: '150%',
              height: '150%',
              className: 'inset-0',
            }}
          />
        </div>
      </li>
    </ConditionalRenderer>
  );
}
